var map = {
	"./Ancient Blue Dragon.png": 1722,
	"./Ancient Green Dragon.png": 1723,
	"./Ancient Red Dragon.png": 1724,
	"./Ancient Yellow Dragon.png": 1725,
	"./Bandit.png": 205,
	"./Beb.png": 1726,
	"./Black Dragon.png": 217,
	"./Blue Dragon.png": 206,
	"./Bone Snake.png": 233,
	"./Bunny.png": 1727,
	"./Cactuson King.png": 216,
	"./Cactuson.png": 215,
	"./Catson Archer.png": 222,
	"./Catson Guard.png": 223,
	"./Catson King.png": 218,
	"./Catson.png": 204,
	"./Cave Goblin Trapper.png": 237,
	"./Cave Goblin.png": 251,
	"./Ceb.png": 1728,
	"./Chicken.png": 294,
	"./Chucken.png": 235,
	"./Clay Golem.png": 265,
	"./Crablante.png": 1729,
	"./Crossbow Tigerman.png": 1730,
	"./Cultist.png": 1731,
	"./Cursed Yeti.png": 1732,
	"./Damascus Dragon.png": 253,
	"./Dead Eye Jones.png": 1733,
	"./Deb.png": 1734,
	"./Dehydrated Cactuson.png": 263,
	"./Demon Prince.png": 1735,
	"./Demonic Bunny.png": 1736,
	"./Dwarf Guard.png": 208,
	"./Dwarf.png": 214,
	"./Earth Elemental.png": 220,
	"./Earth Slime.png": 232,
	"./Easter Bunny.png": 1737,
	"./Enraged Cactuson.png": 277,
	"./Fairy King.png": 244,
	"./Fairy Knight.png": 238,
	"./Fairy Queen.png": 267,
	"./Fairy Rider.png": 245,
	"./Fairy Warrior.png": 272,
	"./Fairy.png": 271,
	"./Fire Demon.png": 260,
	"./Fire Elemental.png": 258,
	"./Fire Giant.png": 259,
	"./Fire Slime.png": 304,
	"./Fire Snake.png": 257,
	"./Flowering Cactuson.png": 262,
	"./Forest Demon.png": 1738,
	"./Frogman Ambassador.png": 280,
	"./Frogman Archer.png": 308,
	"./Frogman King.png": 301,
	"./Frogman Mage.png": 307,
	"./Frogman Warrior.png": 302,
	"./Frogman.png": 300,
	"./Frost Demon.png": 1739,
	"./Frost Giant.png": 240,
	"./Giant Bear.png": 236,
	"./Giant Skeleton.png": 219,
	"./Giant Spider.png": 287,
	"./Glitch Hop the Buggy.png": 1740,
	"./Goat King.png": 1741,
	"./Goatman.png": 268,
	"./Goblin Berserker.png": 282,
	"./Goblin Champion.png": 255,
	"./Goblin King.png": 254,
	"./Goblin Swashbuckler.png": 306,
	"./Goblin Warrior.png": 283,
	"./Goblin.png": 288,
	"./Greater Earth Slime.png": 273,
	"./Greater Fire Slime.png": 278,
	"./Greater Lightning Slime.png": 256,
	"./Greater Slime.png": 286,
	"./Greater Water Slime.png": 281,
	"./Greater Wind Slime.png": 266,
	"./Green Dragon.png": 212,
	"./Guard.png": 105,
	"./Hat Demon.png": 1742,
	"./Highwayman.png": 234,
	"./Jaime Goliver.png": 1743,
	"./Lesser Demon.png": 270,
	"./Lesser Earth Slime.png": 305,
	"./Lesser Fire Slime.png": 210,
	"./Lesser Lightning Slime.png": 252,
	"./Lesser Slime.png": 289,
	"./Lesser Water Slime.png": 291,
	"./Lesser Wind Slime.png": 250,
	"./Lieutenant Cae.png": 1744,
	"./Lieutenant Cra.png": 1745,
	"./Lieutenant Pom.png": 1746,
	"./Lightning Slime.png": 298,
	"./Man.png": 284,
	"./Money Bags.png": 1747,
	"./Mutated Frogman.png": 1748,
	"./Mutated Hydra.png": 1749,
	"./Orc Archer.png": 230,
	"./Orc Berserker.png": 274,
	"./Orc King.png": 226,
	"./Orc Shaman.png": 225,
	"./Orc War Chief.png": 275,
	"./Orc Warrior.png": 224,
	"./Orc.png": 227,
	"./Owlman Archer.png": 248,
	"./Owlman King.png": 246,
	"./Owlman Sage.png": 247,
	"./Owlman Warrior.png": 207,
	"./Owlman.png": 249,
	"./Phoenix.png": 1750,
	"./Psychic Orc.png": 229,
	"./Punk.png": 1751,
	"./Rat.png": 279,
	"./Ratman Berserker.png": 264,
	"./Ratman Guard.png": 296,
	"./Ratman King.png": 297,
	"./Ratman.png": 295,
	"./Red Dragon.png": 243,
	"./Sand Demon.png": 276,
	"./Science Punk.png": 1752,
	"./Skelly Spider.png": 1753,
	"./Slime.png": 290,
	"./Small Bone Snake.png": 269,
	"./Storm Giant.png": 303,
	"./Swamp Demon.png": 292,
	"./The Jealous Witch.png": 1754,
	"./Tigerman Archer.png": 239,
	"./Tigerman Captain.png": 1755,
	"./Tigerman Fighter.png": 213,
	"./Tigerman King.png": 241,
	"./Tigerman.png": 242,
	"./Tikitama.png": 1756,
	"./Tortoise.png": 261,
	"./Unicorn.png": 1757,
	"./Utalagu.png": 1758,
	"./Water Elemental.png": 211,
	"./Water Slime.png": 293,
	"./Wind Elemental.png": 228,
	"./Wind Slime.png": 209,
	"./Wolfman.png": 221,
	"./Woman.png": 285,
	"./Yellow Dragon.png": 231,
	"./Zenitsu.png": 1759,
	"./Zombie.png": 299,
	"./Zorgling.png": 1760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1721;